import {
  AreaUnitSchema,
  ItemUnitSchema,
  LegacyItemUnitSchema,
  type ConversionUnit,
  type ItemUnit,
} from "@forgepoint/shared";

const LEGACY_ITEM_UNITS = new Set<ItemUnit>(LegacyItemUnitSchema.options);

/**
 * Returns selectable item units while preserving an already stored value.
 * @param epicorPrimitiveSupportEnabled - Whether extended item units are available
 * @param currentValue - The currently stored unit, if any
 * @returns Item units available for selection
 */
export function getItemUnitOptions(
  epicorPrimitiveSupportEnabled: boolean,
  currentValue?: string | null,
): ItemUnit[] {
  return selectableItemUnits(epicorPrimitiveSupportEnabled, [currentValue]);
}

/**
 * Returns selectable unit conversion units: the item units, keeping every
 * stored value selectable, plus the area units.
 * @param epicorPrimitiveSupportEnabled - Whether extended item units are available
 * @param currentValues - The currently stored units, if any
 * @returns Conversion units available for selection
 */
export function getConversionUnitOptions(
  epicorPrimitiveSupportEnabled: boolean,
  currentValues: readonly string[] = [],
): ConversionUnit[] {
  return [
    ...selectableItemUnits(epicorPrimitiveSupportEnabled, currentValues),
    ...AreaUnitSchema.options,
  ];
}

function selectableItemUnits(
  epicorPrimitiveSupportEnabled: boolean,
  storedValues: readonly (string | null | undefined)[],
): ItemUnit[] {
  return ItemUnitSchema.options.filter(
    (unit) =>
      epicorPrimitiveSupportEnabled ||
      LEGACY_ITEM_UNITS.has(unit) ||
      storedValues.includes(unit),
  );
}
